import React from "react";
import { Redirect } from "react-router-dom";
import MainContent from "./MainContent";
import ContactHelp from "./ContactHelp";
import { GrowToFullSize } from "./AnimationLibrary";

const Confirmation = props => {
	if (!props.user.netid) return <Redirect push from="/confirmation" to="/" />;

	return (
		<>
			<MainContent user={props.user} step="3" sideBar={true} showStepProgress={true}>
				<div className="main-message-container">
					<p className="intro-text">Good news! Your account password has now been set.</p>
					<p>
						If you’d like to begin using services like email right away, you’ll need to improve the security of your
						account with{" "}
						<a
							target="_blank"
							rel="noopener noreferrer"
							href="https://services.dartmouth.edu/TDClient/1806/Portal/KB/ArticleDet?ID=64933"
						>
							Duo two-factor authentication service.
						</a>{" "}
						You will need your NetID and password to enroll.
					</p>
					<p className="mb-0">
						If it’s not a good time, don’t worry. You’ll be prompted to enroll the first time you use any Duo-protected
						service.
					</p>

					<GrowToFullSize>
						<a href="https://2faenroll.dartmouth.edu" className="btn">
							Enroll in Duo Now
						</a>
					</GrowToFullSize>

					<p className="mt-0">Once your account is secured with Duo, you can begin to use your email.</p>
					<p>
						Use your email:{" "}
						<a target="_blank" rel="noopener noreferrer" href="http://blitz.dartmouth.edu">
							blitz.dartmouth.edu
						</a>
						<br />
						Your email address: <a href={`mailto:` + props.user.email}>{props.user.email}</a>
					</p>
					<p>
						<a href="http://home.dartmouth.edu">I'll enroll in Duo later. Exit for now.</a>
					</p>
				</div>
			</MainContent>
			<ContactHelp />
		</>
	);
};

export default Confirmation;
